import { errorMessages } from '@/globals/errorMessages';
import store from '@/store';
import { post } from './api/http.service';
import arobaPublicAxios from '../services/axios/aroba-oapi-axios.service';
import { mapEventList } from '@/utils/event';

export default class EventService {
  async getEventList(params = {}) {
    let url = '/ccs/v1/event/history';
    // if (params.startDate || params.searchKeys.length) {
    //   url = "camera/event/search";
    // }

    // strip meta fields (keys starting with __) before sending to API
    const sendParams = { ...params };
    Object.keys(sendParams).forEach((key) => {
      if (key.startsWith('__')) {
        delete sendParams[key];
      }
    });

    return post(url, sendParams)
      .then(function (response) {
        return response;
      })
      .catch(function (err) {
        console.log(err);
        return errorMessages.API_ERROR;
      });
  }

  setEvent(data) {
    store.dispatch('event/changeEvent', data);
  }

  async downloadThumbnail(params = {}) {
    const options = {
      headers: {
        Accept: 'application/jpg',
        'Content-Type': 'application/jpg',
      },
    };

    return arobaPublicAxios
      .post(
        process.env.VUE_APP_API_BASE_URL + '/ccs/v1/camera/thumbnail',
        params,
        options
      )
      .then((res) => {
        return res.data;
      });
  }
  getEventByEventId(id) {
    const params = {
      exclusiveStartEventId: +id,
      searchDirection: 1,
      upperLimit: 1,
    };
    return this.getEventList(params).then((result) => {
      params.exclusiveStartEventId = +result.list[0].eventId;
      params.searchDirection = 0;
      params.upperLimit = 1;
      return this.getEventList(params).then((result) => {
        const targetEvent = mapEventList(result.list).find(
          (e) => +e.eventId === +id
        );
        return targetEvent;
      });
    });
  }
}

export const eventService = new EventService();
